module.exports = __webpack_public_path__ + "img/613.4ecb2637.png";